import React, { PureComponent } from 'react';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ProfileActivity from './ProfileActivity';
import {environment} from '../../../../containers/environment';
import { util } from "../../../../../src/shared/util";

const Ava1 = `${process.env.PUBLIC_URL}/img/profile-photo.png`;

class ProfileActivities extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      histories: []
    };
  }

  componentDidUpdate(prevProps) {
    if(prevProps.histories !== this.props.histories){
      this.setState({ histories: this.props.histories});
    }
  }

  render() {
    const { t } = this.props;

    let img = `${process.env.PUBLIC_URL}/img/`;
    let clientName = '';
    let qty = 0;
    let qtyMedida = '';
    let product = '';
    let description = '';
    let activities = [];

    const total = this.state.histories.length;
    for(let i = 0; i < total; i++){
      qty = this.state.histories[i].qty;
      qtyMedida = this.state.histories[i].qtyMedida;

      if(qtyMedida === ""){
        if(this.state.histories[i].inUse){
          product = t('forms.machineUser_form_edit.startLease');
        }else{
          product = t('forms.machineUser_form_edit.endLease');
        }
        product = product + " (Cod. " + this.state.histories[i].code + ") ";
      }else{
        if(qtyMedida === "kg"){
          product = qty + ' ' + qtyMedida;
        }else{
          product = (qty > 1) ? qty + ' ' + qtyMedida + 's' : qty + ' ' + qtyMedida;
        }
      }

      clientName = '';
      if(environment.isAdmin()){
        clientName = ' (' + 
          this.state.histories[i].firstName + ' ' + 
          this.state.histories[i].lastName + ')';
      }

      description = this.state.histories[i].description;
      activities.push(
        <ProfileActivity 
          key={'profAct_' + this.state.histories[i].key} 
          img={img + this.state.histories[i].img} 
          date={util.getDiff(this.state.histories[i].createdAt) + clientName}
          name={this.state.histories[i].name}>
          <p>
            {product}
            {'  ' + util.currencyMask(this.state.histories[i].price)}
            <br />
            {description !== '' ? util.initUpperCase(description) : ''}
          </p>
        </ProfileActivity>
      );
    }
  

    return (
      <div>
        {activities}
      </div>
    );
  }
}

export default reduxForm({
  form: 'profile_activities_form', // a unique identifier for this form
})(withTranslation('common')(ProfileActivities));